import { ThreeDots } from "react-loader-spinner";
import { Title } from "../typography";
import { colors } from "../../assets/styles/parameters";
import styled from "styled-components";

export const Loading = () => {
  return (
    <BaseLoaderSection>
      <Title number={1}>Loading</Title>
      <ThreeDots
        height="80"
        width="80"
        radius="9"
        color={colors.gold}
        ariaLabel="three-dots-loading"
        visible={true}
      />
    </BaseLoaderSection>
  );
};

const BaseFlex = `
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
`;

const BaseLoaderSection = styled.div`
  ${BaseFlex}
  position: absolute;
  background: ${colors.gray100};
  opacity: 0.5;
  height: 100vh;
  width: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1000000;
`;
